import { apiClient } from './client'

export type ContentPromotionStatus = 'create' | 'update' | 'unchanged' | 'incomplete' | 'productionOnly' | 'blocked'

export type ContentPromotionRecord = {
  kind: 'operator' | 'tour' | 'popularHike' | 'badge' | 'hikeStrongChallenge' | 'seasonalChallenge' | 'exercise' | 'exerciseVideo' | 'exerciseTrackerInstruction' | 'fitnessHikeTarget'
  sourceId: string
  targetId?: string | null
  name: string
  operatorName?: string | null
  status: ContentPromotionStatus
  changedFields: string[]
  preservedFields: string[]
  warnings: string[]
  sourceImageCount: number
  targetImageCount: number
}

export type ContentPromotionPreview = {
  sourceEnvironment: 'staging'
  targetEnvironment: 'production'
  currentEnvironment: 'staging' | 'production' | 'local'
  canApply: boolean
  isConfigured: boolean
  recoveryPending?: boolean
  configurationMessage?: string | null
  changeToken: string
  comparedAtUtc: string
  summary: {
    creates: number
    updates: number
    unchanged: number
    productionOnlyPreserved: number
    blocked: number
    missingSourceImages: number
    imageConflicts: number
  }
  records: ContentPromotionRecord[]
}

export type ContentPromotionApplyResult = {
  appliedAtUtc: string
  appliedBy: string
  created: number
  updated: number
  changedRecords: ContentPromotionRecord[]
  notApplied: ContentPromotionRecord[]
  readback: ContentPromotionPreview
}

export async function getContentPromotionPreview() {
  const { data } = await apiClient.get<ContentPromotionPreview>('/api/admin/content-promotion/preview')
  return data
}

export async function applyContentPromotion(changeToken: string, confirmation: string) {
  const { data } = await apiClient.post<ContentPromotionApplyResult>('/api/admin/content-promotion/apply', {
    changeToken,
    confirmation
  })
  return data
}
